import { loadEdjsContent } from '@/js/components/loadEdjs';

const main = async () => {
    if(!document.querySelector('#page-news-show')) return;

    const id = document.querySelector('.post').getAttribute('data-id');
    await loadEdjsContent('news', id, 'body', '.content');
}
export default main;
